import { DataObject } from '@/utils/DataObject';
import { Artwork } from '../artwork/Artwork';
import { ArtistTransformer } from '../artist/ArtistTransformer';
import { MediaTransformer } from '../media/MediaTransformer';
import { GalleryTransformer } from '../galleries/GalleryTransformer';

export class SearchTransformer {

  private parseDimension(data: DataObject = {}): string | null {
    if (!data.height && !data.width && !data.depth) return null;
    return `${data.height} x ${data.width} x ${data.depth} [cm]`;
  }

  private getFallbackText(locale: string, data: DataObject = {}): string {
    let text = "";
    switch (locale) {
      case "en":
        text = data['fi'] || data['se'];
        break;
      case "fi":
        text = data['en'] || data['se']
        break;
      case "se":
        text = data['en'] || data['fi']
        break;
    }
    return text;
  }

  toClass(data: DataObject = {}, locale: 'fi' | 'se' | 'en'): Artwork {

    // (val * 100 / 100).toFixed(2) + "€";
    return new Artwork({
      id: data.id,
      title: data.title[locale] || this.getFallbackText(locale, data.title),
      slug: data.slug,
      // description: data.description[locale] || this.getFallbackText(locale, data.description),
      price: (data.price).toFixed(2).replace('.', ','),
      isForSale: !!data.is_for_sale,
      dimension: this.parseDimension(data),
      media: new MediaTransformer().toClass(data.media),
      mediaCount: data.media_count,
      artist: new ArtistTransformer().toClass(data.artist),
      path: data.path,
      isTestable: data.is_testable,
      orderColumn: data.order_column,
      publishedAt: data.published_at || null,
      virtual_exhibition: data.virtual_exhibition ? new GalleryTransformer().toClass(data.virtual_exhibition) : null,
      video_id: data.video_id,
    });
  }

}